import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Select from "react-select";

import moment from "moment";
import "react-widgets/styles.css";
import DatePicker from "react-widgets/DatePicker";
import momentLocalizer from "react-widgets-moment";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import { obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
import { getIdEmpresa } from "../../../api/utils";
import { obtenerConsolidado } from "../../../api/reportes";
import { exportarLink } from "../../../utils/shared-functions";
import LoadingComponent from "../../../components/loading-component";
import { useTranslation } from "react-i18next";
import { STRING_COLOR_PRIMARIO, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../../../utils/const/string-const";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { obtenerPermisos } from "../../../api/api-permisos";
import { INT_TIPO_USUARIO_ADMINISTRADOR_WEB } from "../../../utils/const/int-const";
import { PAGE_ID } from "../../../utils/const/pages-const";
import cargandoCard from "../../../components/cargando-card";
import SinAccesoCard from "../../../components/sin-acceso-card";
new momentLocalizer(moment);

export default function ConsolidadoRespuestas() {

    const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
    const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);

    const { t } = useTranslation();
    const history = useHistory();
    const [fechaInicio, setFechaInicio] = useState(new Date(moment().clone().startOf("week").format("YYYY-MM-DD")));
    const [fechaFin, setFechaFin] = useState(new Date(moment().clone().endOf("week").format("YYYY-MM-DD")));
    const [listaUnidades, setListaUnidades] = useState([]);
    const [unidadSelected, setUnidadSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
    const [cargandoPage, setCargandoPage] = useState(true);
    const [btnBuscar, setBtnBuscar] = useState(false);

    useEffect(() => {
        // console.log("entro a listar correo");
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
            if (colorBase !== null) {
                setColorMain(colorBase);
            }
            // let permiso = null;
            if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                setBtnBuscar(true);
                const todasLasUnidades = await obtenerTodasLasUnidades();
                // console.log('todasLasUnidades');
                // console.log(todasLasUnidades);
                todasLasUnidades.unshift({ value: 'TODOS', label: "TODOS" });
                setListaUnidades(todasLasUnidades);
                setTieneAccesoAlModulo(true);
            }
            if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
                const objEnviar = {
                    idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
                };
                const permisos = await obtenerPermisos(objEnviar);
                if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
                    const permisosData = permisos.data[0];
                    // console.log('permisosData');
                    // console.log(permisosData);
                    const unidades = JSON.parse(permisosData.unidades);
                    // console.log('unidades');
                    // console.log(unidades);
                    unidades.unshift({ value: 'TODOS', label: "TODOS" });
                    setListaUnidades(unidades);
                    const parsePermisos = JSON.parse(permisosData.permisos);
                    const permisosConsolidadoRespuestas = parsePermisos.find(e => e.value === PAGE_ID.CONSOLIDADO_RESPUESTAS_CHECKLIST);
                    if (permisosConsolidadoRespuestas !== undefined) {
                        const acciones = permisosConsolidadoRespuestas.acciones;
                        if (acciones !== undefined) {
                            const buscar = acciones.find(e => e.value === 'btn_buscar');
                            if (buscar !== undefined) {
                                setBtnBuscar(buscar.checked);
                            }
                        }
                    }
                    const permisosInfo = JSON.parse(permisos.data[0].permisos);
                    // console.log('permisosInfo');
                    // console.log(permisosInfo);
                    const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.CONSOLIDADO_RESPUESTAS_CHECKLIST);
                    // console.log('permisosPage');
                    // console.log(permisosPage);
                    setTieneAccesoAlModulo(permisosPage.checked === true);
                }
            }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const handleBtnAtras = async () => {
        try {
            history.goBack();
        } catch (err) {
            console.log("handleBuscar err");
            console.log(err);
        }
    };

    const handleBuscar = async () => {
        try {
            // console.log("handleBuscar");
            if (unidadSelected === null) {
                alert(t("alert_debe_seleccionar_unidad"));
                return;
            }
            if (moment(fechaInicio).isValid() === false || moment(fechaFin).isValid() === false) {
                alert(t("alert_debe_seleccionar_fechas_validas"));
                return;
            }
            let placaSelected = unidadSelected.value;
            if (placaSelected === 'TODOS') {
                const unidades = [...listaUnidades];
                unidades.shift();
                placaSelected = unidades.map(e => e.value).join(',');
            }
            setLoading(true);
            let objEnviar = {};
            objEnviar.idEmpresa = getIdEmpresa();
            objEnviar.fechaInicio = moment(fechaInicio).format("YYYY-MM-DD") + " 00:00:00";
            objEnviar.fechaFin = moment(fechaFin).format("YYYY-MM-DD") + " 23:59:59";
            objEnviar.placa = placaSelected;
            const response = await obtenerConsolidado(objEnviar);
            if (response.error === false) {
                const nombre = response.data.split("/");
                exportarLink('https://gestiondeflota.boltrack.net/assets/reportes/' + nombre[nombre.length - 1], nombre[nombre.length - 1]);
            }
            setLoading(false);
        } catch (err) {
            console.log("handleBuscar err");
            console.log(err);
            setLoading(false);
        }
    };

    const handleUnidadSelected = async (event) => {
        try {
            setUnidadSelected(event);
        } catch (err) {
            console.log('handleUnidadSelected err');
            console.log(err);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return SinAccesoCard();
            }
            return (
                <div className="mt-5 ml-5 mr-5">
                    <div className="flex justify-between">
                        <label
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            {t("titulo_consolidado_respuestas_checklist")}
                        </label>
                        <button
                            className={ESTILO_BOTON_LISTAR_ATRAS}
                            onClick={handleBtnAtras}
                        >
                            {t("btn_atras")}
                        </button>
                    </div>
                    {/* <br /> */}
                    <hr />
                    <br />
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
                            <label htmlFor="unidad" className="mb-2 font-bold">
                                {t("label_unidad")}
                            </label>
                            <Select options={listaUnidades} isSearchable='true'
                                isClearable='true'
                                value={unidadSelected}
                                onChange={(event) => handleUnidadSelected(event)}
                                placeholder='SELECCIONE UNIDAD'
                            />
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
                            <label htmlFor="fecha inicio" className="mb-2 font-bold">
                                {t("label_fecha_inicio")}
                            </label>
                            <DatePicker
                                defaultValue={fechaInicio}
                                value={fechaInicio}
                                valueFormat={{ dateStyle: "medium" }}
                                onChange={(date) => setFechaInicio(date)}
                            />
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
                            <label htmlFor="fecha fin" className="mb-2 font-bold">
                                {t("label_fecha_fin")}
                            </label>
                            <DatePicker
                                defaultValue={fechaFin}
                                value={fechaFin}
                                valueFormat={{ dateStyle: "medium" }}
                                onChange={(date) => setFechaFin(date)}
                            />
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2 flex justify-end items-center">
                            {btnBuscar === true && (
                                <button
                                    className={`${ESTILO_BOTON_LISTAR_NUEVO} h-fit py-2`}
                                    style={{
                                        backgroundColor: colorMain,
                                    }}
                                    onClick={handleBuscar}
                                >
                                    {t("btn_buscar")}
                                </button>
                            )}
                        </div>
                    </div>
                    <LoadingComponent
                        isOpen={loading}
                    />
                </div>
            );
        } catch (err) {
            console.log('ConsolidadoRespuestas render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    }

    return render();
}
